var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("Back")]),_c('button',{staticClass:"btn btn-danger m-5",on:{"click":function($event){return _vm.deleteTank()}}},[_vm._v("DELETE")])])
}
var staticRenderFns = []

export { render, staticRenderFns }